import { render, staticRenderFns } from "./SendPatientInviteWithTextMessage.vue?vue&type=template&id=afe83446&scoped=true"
import script from "./SendPatientInviteWithTextMessage.vue?vue&type=script&lang=js"
export * from "./SendPatientInviteWithTextMessage.vue?vue&type=script&lang=js"
import style0 from "./SendPatientInviteWithTextMessage.vue?vue&type=style&index=0&id=afe83446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe83446",
  null
  
)

export default component.exports